import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule, MatSelectModule } from '@angular/material';

import { MyFilterPipe } from './myfilter.pipe';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { DbmListComponent } from './dbm-list.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PipesModule,
        DirectivesModule,
        MatCheckboxModule,
        MatSelectModule
    ],
    declarations: [
        MyFilterPipe,
        DbmListComponent
    ],
    providers: [MyFilterPipe],
    exports: [DbmListComponent, MyFilterPipe],
    entryComponents: [DbmListComponent]
})
export class DbmListModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-list/dbm-list.module.ts